// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BSG-compliant styles while maintaining original design */
* {
  box-sizing: border-box;
}

/* Skip link for keyboard navigation */
.bsg-skip-link {
  position: absolute;
  top: -9999px;
  left: -9999px;
  background: white;
  color: var(--ion-color-secondary);
  padding: 15px;
  z-index: 10000;
  font-weight: bold;
  border: 2px solid var(--ion-color-secondary);
}
.bsg-skip-link:focus {
  top: 0;
  left: 0;
}

ion-content {
  background: url('home_background.png') no-repeat center center/105% 105%;
  position: relative;
  /* Add keyboard focus styles */
}
ion-content.bsg-keyboard-mode *:focus {
  outline: 2px solid var(--ion-color-primary) !important;
  outline-offset: 2px !important;
  box-shadow: 0 0 0 4px rgba(126, 167, 105, 0.25) !important;
}
ion-content .order-types {
  width: 70%;
  margin: 0 auto;
}
@media (max-width: 992px) {
  ion-content .order-types {
    width: 100%;
    padding: 10px;
  }
}
ion-content .order-types .padding-block {
  height: 30vh;
}
@media (max-width: 992px) {
  ion-content .order-types .padding-block {
    height: 30px;
  }
}
ion-content .order-types .info_block {
  width: -moz-fit-content;
  width: fit-content;
  padding: 20px;
  background: white;
  box-shadow: 0px 4px 15px 0px rgba(13, 71, 161, 0.1490196078);
  border-radius: 16px;
  /* Make sure keyboard focus is visible */
}
@media (max-width: 992px) {
  ion-content .order-types .info_block {
    width: 100%;
  }
}
ion-content .order-types .info_block:focus-within {
  box-shadow: 0px 4px 15px 0px rgba(13, 71, 161, 0.3764705882);
}
ion-content .order-types h4 {
  font-size: 24px;
  color: var(--ion-color-secondary);
  text-align: center;
  text-transform: uppercase;
  margin-top: 15px;
}
ion-content .order-types .order-types-blocks {
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-direction: column;
}
ion-content .order-types .order-types-blocks .order-type-item {
  width: 100% !important;
  border-radius: 10px;
  box-shadow: 0px 4px 15px 0px rgba(13, 71, 161, 0.1490196078);
  overflow: hidden;
  margin: 10px 0px;
  padding: 15px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border: 1px solid transparent;
  transition: border 0.3s ease-in-out;
  cursor: pointer;
  /* Keyboard accessibility enhancements */
  /* Selected state */
}
ion-content .order-types .order-types-blocks .order-type-item:focus {
  border: 1px solid var(--ion-color-primary);
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
  box-shadow: 0 0 0 4px rgba(126, 167, 105, 0.25);
}
ion-content .order-types .order-types-blocks .order-type-item:focus p {
  animation: moveAndShow 0.5s ease-in-out forwards;
  opacity: 1;
}
ion-content .order-types .order-types-blocks .order-type-item:focus ion-icon {
  animation: moveIcon 0.5s ease-in-out forwards;
}
ion-content .order-types .order-types-blocks .order-type-item:hover {
  border: 1px solid #7ea769;
}
ion-content .order-types .order-types-blocks .order-type-item:hover p {
  animation: moveAndShow 0.5s ease-in-out forwards;
  opacity: 1;
}
ion-content .order-types .order-types-blocks .order-type-item:hover ion-icon {
  animation: moveIcon 0.5s ease-in-out forwards;
}
ion-content .order-types .order-types-blocks .order-type-item.selected {
  border: 1px solid #7ea769;
  background-color: rgba(126, 167, 105, 0.1);
}
ion-content .order-types .order-types-blocks .order-type-item.selected::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: var(--ion-color-primary);
}
ion-content .order-types .order-types-blocks .order-type-item .logo-block {
  width: 62px;
  height: 62px;
  background: var(--ion-color-primary);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
ion-content .order-types .order-types-blocks .order-type-item .logo-block ion-icon {
  fill: white;
  width: -webkit-fill-available;
  width: 35px;
  height: 35px;
  position: absolute;
}
ion-content .order-types .order-types-blocks .order-type-item .text-block {
  width: calc(100% - 62px);
  padding: 0px 20px;
}
ion-content .order-types .order-types-blocks .order-type-item .text-block h3 {
  font-size: 16px;
  font-family: AppFontBold, sans-serif;
  color: var(--ion-color-secondary);
  margin-bottom: 15px;
}
ion-content .order-types .order-types-blocks .order-type-item .text-block p {
  width: 100%;
  font-size: 12px;
  color: var(--ion-color-secondary);
  opacity: 0;
}
@media (max-width: 992px) {
  ion-content .order-types .order-types-blocks .order-type-item .text-block p {
    opacity: 1;
  }
}

@keyframes moveIcon {
  0% {
    top: -10px;
  }
  50% {
    top: 10px;
  }
  75% {
    top: -10px;
  }
  100% {
    top: 50%;
    transform: translateY(-50%);
  }
}
@keyframes moveAndShow {
  0% {
    opacity: 0;
    transform: translateX(100%);
  }
  100% {
    opacity: 1;
    transform: translateX(0%);
  }
}
.orders-block {
  width: 100%;
  background: white;
  margin-top: 50px;
  padding: 20px;
}
.orders-block h4 {
  font-size: 22px;
  color: var(--ion-color-secondary);
  text-transform: uppercase;
}
.orders-block .width-wrapper {
  width: 70%;
  margin: 0 auto;
}
@media (max-width: 992px) {
  .orders-block .width-wrapper {
    width: 100%;
  }
}
.orders-block .wrapper-for-orders {
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  overflow-x: auto;
  padding: 10px 0px 15px 10px;
  /* Keyboard navigation support for horizontal scrolling */
}
@media (max-width: 992px) {
  .orders-block .wrapper-for-orders {
    flex-wrap: wrap;
  }
}
.orders-block .wrapper-for-orders:focus-within {
  outline: 2px solid var(--ion-color-primary);
  border-radius: 4px;
}
.orders-block .wrapper-for-orders app-my-order {
  min-width: 33%;
  height: 100%;
  margin-right: 10px;
  /* Make focusable */
}
@media (max-width: 992px) {
  .orders-block .wrapper-for-orders app-my-order {
    min-width: 100%;
  }
}
.orders-block .wrapper-for-orders app-my-order:focus {
  outline: 2px solid var(--ion-color-primary);
  box-shadow: 0 0 0 4px rgba(126, 167, 105, 0.25);
  border-radius: 4px;
}

.news-section {
  padding: 20px 0px 40px 20px;
  display: flex;
  overflow-y: auto;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  /* Keyboard navigation for horizontal scrolling */
}
.news-section:focus-within {
  outline: 2px solid var(--ion-color-primary);
  border-radius: 4px;
}
.news-section app-draw-news-braze-item {
  min-width: 90%;
  /* Make focusable */
}
@media (min-width: 991px) {
  .news-section app-draw-news-braze-item {
    min-width: 35%;
    max-width: 35%;
  }
}
.news-section app-draw-news-braze-item:focus {
  outline: 2px solid var(--ion-color-primary);
  box-shadow: 0 0 0 4px rgba(126, 167, 105, 0.25);
  border-radius: 4px;
}
.news-section h3 {
  text-align: left;
  font-family: AppFontBold, sans-serif;
  color: var(--ion-color-secondary);
  text-align: left;
  width: 100%;
  font-size: 20px;
  padding-left: 20px;
  text-transform: uppercase;
}

/* High contrast mode enhancements */
.bsg-high-contrast .order-types .info_block {
  background: #000000;
  border: 2px solid #ffffff;
}
.bsg-high-contrast .order-type-item {
  background: #000000;
  border: 2px solid #ffffff !important;
}
.bsg-high-contrast .order-type-item.selected {
  border-left: 4px solid #ffff00 !important;
}
.bsg-high-contrast .order-type-item:focus {
  outline: 3px dashed #ffff00 !important;
}
.bsg-high-contrast .order-type-item .logo-block {
  background: #ffff00 !important;
}
.bsg-high-contrast .order-type-item .logo-block ion-icon {
  fill: #000000 !important;
}
.bsg-high-contrast .order-type-item .text-block h3,
.bsg-high-contrast .order-type-item .text-block p {
  color: #ffffff !important;
}
.bsg-high-contrast .order-type-item .text-block p {
  opacity: 1 !important;
}
.bsg-high-contrast .orders-block {
  background: #000000;
  border-top: 2px solid #ffffff;
}
.bsg-high-contrast .orders-block h4 {
  color: #ffff00 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/home/home.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA,2DAAA;AACA;EACC,sBAAA;AADD;;AAIA,sCAAA;AACA;EACC,kBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,iCAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;EACA,4CAAA;AADD;AAGC;EACC,MAAA;EACA,OAAA;AADF;;AAKA;EACC,wEAAA;EACA,kBAAA;EAEA,8BAAA;AAHD;AAIC;EACC,sDAAA;EACA,8BAAA;EACA,0DAAA;AAFF;AAKC;EACC,UAAA;EACA,cAAA;AAHF;AC5BE;ED6BD;IAIE,WAAA;IACA,aAAA;EADD;AACF;AAGE;EACC,YAAA;AADH;ACrCE;EDqCA;IAGE,YAAA;EACF;AACF;AAEE;EACC,uBAAA;EAAA,kBAAA;EAIA,aAAA;EACA,iBAAA;EACA,4DAAA;EACA,mBAAA;EAEA,wCAAA;AAJH;AClDE;ED4CA;IAGE,WAAA;EAOF;AACF;AAAG;EACC,4DAAA;AAEJ;AAEE;EACC,eAAA;EACA,iCAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AAAH;AAGE;EACC,aAAA;EACA,8BAAA;EACA,WAAA;EACA,sBAAA;AADH;AAGG;EACC,sBAAA;EACA,mBAAA;EACA,4DAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,6BAAA;EACA,mCAAA;EACA,eAAA;EAEA,wCAAA;EA4BA,mBAAA;AA7BJ;AAEI;EACC,0CAAA;EACA,2CAAA;EACA,mBAAA;EACA,+CAAA;AAAL;AAEK;EACC,gDAAA;EACA,UAAA;AAAN;AAGK;EACC,6CAAA;AADN;AAKI;EACC,yBAAA;AAHL;AAIK;EACC,gDAAA;EACA,UAAA;AAFN;AAIK;EACC,6CAAA;AAFN;AAOI;EACC,yBAAA;EACA,0CAAA;AALL;AAOK;EACC,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,0CAAA;AALN;AASI;EACC,WAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAPL;AASK;EACC,WAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAPN;AAWI;EACC,wBAAA;EACA,iBAAA;AATL;AAWK;EACC,eAAA;EACA,oCAAA;EACA,iCAAA;EACA,mBAAA;AATN;AAYK;EACC,WAAA;EACA,eAAA;EACA,iCAAA;EACA,UAAA;AAVN;AC5JE;EDkKG;IAME,UAAA;EARL;AACF;;AAgBA;EACC;IACC,UAAA;EAbA;EAeD;IACC,SAAA;EAbA;EAeD;IACC,UAAA;EAbA;EAeD;IACC,QAAA;IACA,2BAAA;EAbA;AACF;AAgBA;EACC;IACC,UAAA;IACA,2BAAA;EAdA;EAgBD;IACC,UAAA;IACA,yBAAA;EAdA;AACF;AAiBA;EACC,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;AAfD;AAiBC;EACC,eAAA;EACA,iCAAA;EACA,yBAAA;AAfF;AAkBC;EACC,UAAA;EACA,cAAA;AAhBF;AC1ME;EDwND;IAIE,WAAA;EAdD;AACF;AAiBC;EACC,aAAA;EACA,2BAAA;EACA,iBAAA;EACA,gBAAA;EACA,2BAAA;EAKA,yDAAA;AAnBF;ACvNE;EDgOD;IAOE,eAAA;EAZD;AACF;AAeE;EACC,2CAAA;EACA,kBAAA;AAbH;AAgBE;EACC,cAAA;EAIA,YAAA;EACA,kBAAA;EAEA,mBAAA;AAlBH;ACtOE;EDgPA;IAGE,eAAA;EATF;AACF;AAcG;EACC,2CAAA;EACA,+CAAA;EACA,kBAAA;AAZJ;;AAkBA;EACC,2BAAA;EACA,aAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,iBAAA;EAEA,iDAAA;AAhBD;AAiBC;EACC,2CAAA;EACA,kBAAA;AAfF;AAkBC;EAKC,cAAA;EAEA,mBAAA;AArBF;ACxQE;EDsRD;IAEE,cAAA;IACA,cAAA;EAZD;AACF;AAgBE;EACC,2CAAA;EACA,+CAAA;EACA,kBAAA;AAdH;AAkBC;EACC,gBAAA;EACA,oCAAA;EACA,iCAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;AAhBF;;AAoBA,oCAAA;AAEC;EACC,mBAAA;EACA,yBAAA;AAlBF;AAqBC;EACC,mBAAA;EACA,oCAAA;AAnBF;AAqBE;EACC,yCAAA;AAnBH;AAsBE;EACC,sCAAA;AApBH;AAuBE;EACC,8BAAA;AArBH;AAuBG;EACC,wBAAA;AArBJ;AA0BG;;EAEC,yBAAA;AAxBJ;AA2BG;EACC,qBAAA;AAzBJ;AA8BC;EACC,mBAAA;EACA,6BAAA;AA5BF;AA8BE;EACC,yBAAA;AA5BH","sourcesContent":["@import '../../../theme/mixins';\n\n/* BSG-compliant styles while maintaining original design */\n* {\n\tbox-sizing: border-box;\n}\n\n/* Skip link for keyboard navigation */\n.bsg-skip-link {\n\tposition: absolute;\n\ttop: -9999px;\n\tleft: -9999px;\n\tbackground: white;\n\tcolor: var(--ion-color-secondary);\n\tpadding: 15px;\n\tz-index: 10000;\n\tfont-weight: bold;\n\tborder: 2px solid var(--ion-color-secondary);\n\n\t&:focus {\n\t\ttop: 0;\n\t\tleft: 0;\n\t}\n}\n\nion-content {\n\tbackground: url('../../../assets/demo/home_background.png') no-repeat center center / 105% 105%;\n\tposition: relative;\n\n\t/* Add keyboard focus styles */\n\t&.bsg-keyboard-mode *:focus {\n\t\toutline: 2px solid var(--ion-color-primary) !important;\n\t\toutline-offset: 2px !important;\n\t\tbox-shadow: 0 0 0 4px rgba(126, 167, 105, 0.25) !important;\n\t}\n\n\t.order-types {\n\t\twidth: 70%;\n\t\tmargin: 0 auto;\n\t\t@include mobile {\n\t\t\twidth: 100%;\n\t\t\tpadding: 10px;\n\t\t}\n\n\t\t.padding-block {\n\t\t\theight: 30vh;\n\t\t\t@include mobile {\n\t\t\t\theight: 30px;\n\t\t\t}\n\t\t}\n\n\t\t.info_block {\n\t\t\twidth: fit-content;\n\t\t\t@include mobile {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t\tpadding: 20px;\n\t\t\tbackground: white;\n\t\t\tbox-shadow: 0px 4px 15px 0px #0d47a126;\n\t\t\tborder-radius: 16px;\n\n\t\t\t/* Make sure keyboard focus is visible */\n\t\t\t&:focus-within {\n\t\t\t\tbox-shadow: 0px 4px 15px 0px #0d47a160;\n\t\t\t}\n\t\t}\n\n\t\th4 {\n\t\t\tfont-size: 24px;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t\ttext-align: center;\n\t\t\ttext-transform: uppercase;\n\t\t\tmargin-top: 15px;\n\t\t}\n\n\t\t.order-types-blocks {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\twidth: 100%;\n\t\t\tflex-direction: column;\n\n\t\t\t.order-type-item {\n\t\t\t\twidth: 100% !important;\n\t\t\t\tborder-radius: 10px;\n\t\t\t\tbox-shadow: 0px 4px 15px 0px #0d47a126;\n\t\t\t\toverflow: hidden;\n\t\t\t\tmargin: 10px 0px;\n\t\t\t\tpadding: 15px;\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: flex-start;\n\t\t\t\talign-items: center;\n\t\t\t\tborder: 1px solid transparent;\n\t\t\t\ttransition: border 0.3s ease-in-out;\n\t\t\t\tcursor: pointer;\n\n\t\t\t\t/* Keyboard accessibility enhancements */\n\t\t\t\t&:focus {\n\t\t\t\t\tborder: 1px solid var(--ion-color-primary);\n\t\t\t\t\toutline: 2px solid var(--ion-color-primary);\n\t\t\t\t\toutline-offset: 2px;\n\t\t\t\t\tbox-shadow: 0 0 0 4px rgba(126, 167, 105, 0.25);\n\n\t\t\t\t\tp {\n\t\t\t\t\t\tanimation: moveAndShow 0.5s ease-in-out forwards;\n\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t}\n\n\t\t\t\t\tion-icon {\n\t\t\t\t\t\tanimation: moveIcon 0.5s ease-in-out forwards;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t&:hover {\n\t\t\t\t\tborder: 1px solid #7ea769;\n\t\t\t\t\tp {\n\t\t\t\t\t\tanimation: moveAndShow 0.5s ease-in-out forwards;\n\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t}\n\t\t\t\t\tion-icon {\n\t\t\t\t\t\tanimation: moveIcon 0.5s ease-in-out forwards;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t/* Selected state */\n\t\t\t\t&.selected {\n\t\t\t\t\tborder: 1px solid #7ea769;\n\t\t\t\t\tbackground-color: rgba(126, 167, 105, 0.1);\n\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tcontent: '';\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\twidth: 4px;\n\t\t\t\t\t\tbackground-color: var(--ion-color-primary);\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.logo-block {\n\t\t\t\t\twidth: 62px;\n\t\t\t\t\theight: 62px;\n\t\t\t\t\tbackground: var(--ion-color-primary);\n\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tposition: relative;\n\n\t\t\t\t\tion-icon {\n\t\t\t\t\t\tfill: white;\n\t\t\t\t\t\twidth: -webkit-fill-available;\n\t\t\t\t\t\twidth: 35px;\n\t\t\t\t\t\theight: 35px;\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.text-block {\n\t\t\t\t\twidth: calc(100% - 62px);\n\t\t\t\t\tpadding: 0px 20px;\n\n\t\t\t\t\th3 {\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\t\t\tcolor: var(--ion-color-secondary);\n\t\t\t\t\t\tmargin-bottom: 15px;\n\t\t\t\t\t}\n\n\t\t\t\t\tp {\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\tcolor: var(--ion-color-secondary);\n\t\t\t\t\t\topacity: 0;\n\t\t\t\t\t\t@include mobile {\n\t\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n@keyframes moveIcon {\n\t0% {\n\t\ttop: -10px;\n\t}\n\t50% {\n\t\ttop: 10px;\n\t}\n\t75% {\n\t\ttop: -10px;\n\t}\n\t100% {\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%);\n\t}\n}\n\n@keyframes moveAndShow {\n\t0% {\n\t\topacity: 0;\n\t\ttransform: translateX(100%);\n\t}\n\t100% {\n\t\topacity: 1;\n\t\ttransform: translateX(0%);\n\t}\n}\n\n.orders-block {\n\twidth: 100%;\n\tbackground: white;\n\tmargin-top: 50px;\n\tpadding: 20px;\n\n\th4 {\n\t\tfont-size: 22px;\n\t\tcolor: var(--ion-color-secondary);\n\t\ttext-transform: uppercase;\n\t}\n\n\t.width-wrapper {\n\t\twidth: 70%;\n\t\tmargin: 0 auto;\n\t\t@include mobile {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t.wrapper-for-orders {\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\tflex-wrap: nowrap;\n\t\toverflow-x: auto;\n\t\tpadding: 10px 0px 15px 10px;\n\t\t@include mobile {\n\t\t\tflex-wrap: wrap;\n\t\t}\n\n\t\t/* Keyboard navigation support for horizontal scrolling */\n\t\t&:focus-within {\n\t\t\toutline: 2px solid var(--ion-color-primary);\n\t\t\tborder-radius: 4px;\n\t\t}\n\n\t\tapp-my-order {\n\t\t\tmin-width: 33%;\n\t\t\t@include mobile {\n\t\t\t\tmin-width: 100%;\n\t\t\t}\n\t\t\theight: 100%;\n\t\t\tmargin-right: 10px;\n\n\t\t\t/* Make focusable */\n\t\t\t&:focus {\n\t\t\t\toutline: 2px solid var(--ion-color-primary);\n\t\t\t\tbox-shadow: 0 0 0 4px rgba(126, 167, 105, 0.25);\n\t\t\t\tborder-radius: 4px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.news-section {\n\tpadding: 20px 0px 40px 20px;\n\tdisplay: flex;\n\toverflow-y: auto;\n\tjustify-content: flex-start;\n\talign-items: center;\n\tflex-wrap: nowrap;\n\n\t/* Keyboard navigation for horizontal scrolling */\n\t&:focus-within {\n\t\toutline: 2px solid var(--ion-color-primary);\n\t\tborder-radius: 4px;\n\t}\n\n\tapp-draw-news-braze-item {\n\t\t@include desktop {\n\t\t\tmin-width: 35%;\n\t\t\tmax-width: 35%;\n\t\t}\n\t\tmin-width: 90%;\n\n\t\t/* Make focusable */\n\t\t&:focus {\n\t\t\toutline: 2px solid var(--ion-color-primary);\n\t\t\tbox-shadow: 0 0 0 4px rgba(126, 167, 105, 0.25);\n\t\t\tborder-radius: 4px;\n\t\t}\n\t}\n\n\th3 {\n\t\ttext-align: left;\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tcolor: var(--ion-color-secondary);\n\t\ttext-align: left;\n\t\twidth: 100%;\n\t\tfont-size: 20px;\n\t\tpadding-left: 20px;\n\t\ttext-transform: uppercase;\n\t}\n}\n\n/* High contrast mode enhancements */\n.bsg-high-contrast {\n\t.order-types .info_block {\n\t\tbackground: #000000;\n\t\tborder: 2px solid #ffffff;\n\t}\n\n\t.order-type-item {\n\t\tbackground: #000000;\n\t\tborder: 2px solid #ffffff !important;\n\n\t\t&.selected {\n\t\t\tborder-left: 4px solid #ffff00 !important;\n\t\t}\n\n\t\t&:focus {\n\t\t\toutline: 3px dashed #ffff00 !important;\n\t\t}\n\n\t\t.logo-block {\n\t\t\tbackground: #ffff00 !important;\n\n\t\t\tion-icon {\n\t\t\t\tfill: #000000 !important;\n\t\t\t}\n\t\t}\n\n\t\t.text-block {\n\t\t\th3,\n\t\t\tp {\n\t\t\t\tcolor: #ffffff !important;\n\t\t\t}\n\n\t\t\tp {\n\t\t\t\topacity: 1 !important;\n\t\t\t}\n\t\t}\n\t}\n\n\t.orders-block {\n\t\tbackground: #000000;\n\t\tborder-top: 2px solid #ffffff;\n\n\t\th4 {\n\t\t\tcolor: #ffff00 !important;\n\t\t}\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
